import React from 'react';
import { Card, Col} from 'reactstrap';
import CardImage from '../elements/cardImage'
import CardUpdate from '../elements/cardUpdates';
import CardDetail from '../elements/cardDetail';

const BeneficiaryCard = ({
	beneficiary, toggle, position, keyy
}) => (
	// <Col lg="5" sm="6" xs="12" className="d-flex">
	<Col xs="12" className="d-flex"> 
		<a
			onClick={() => toggle(position, keyy)}
			className="darker-grey no-hover-a w-100"
		>
			<Card className="w-100">
				<CardImage
					image={beneficiary.image}
					imageLoading={beneficiary.image}
					alt={beneficiary.name}
				/>
				{/* <div className="card-body pt-3 pb-3">
					<CardDetail
						name={beneficiary.name}
						age={beneficiary.age}
						gender={beneficiary.gender}
						location={beneficiary.location}
					/>
				</div> */}
				{/* <CardUpdate
					number={getUpdateCount(beneficiary.updates)}
					toggle={toggle}
					position={position}
				/> */}
				{/* Particular Button Component Will Go Here */}
				<button className="d-flex justify-content-center align-items-center" style={{height:39,border:'1px solid coral',borderRadius:5,marginTop:10,background:'#fff'}}>
					<span style={{color:'#ff5050'}}>3 updates available</span>
				</button>
			</Card>
		</a>
	</Col>
);

const getUpdateCount = (updates) => {
	try {
		if (typeof updates === 'undefined' || updates === null) {
			return 0;
		}
		return updates.length
	} catch (err) {
		return 0;
	}
}

export default BeneficiaryCard;
